import { IProformaInvoice, IProformaInvoicePersistence } from '../interfaces';

export class ProformaInvoiceMapper {
  public static toDomain(p: IProformaInvoicePersistence): IProformaInvoice {
    return {
      user: {
        id: p.user.id,
        fullName: p.user.user_name,
        phoneNumber: p.user.number,
        country: p.user.country,
        city: p.user.city,
        address: p.user.address,
      },
      items: p.declarations.map((d) => ({
        trackCode: d.track_code,
        quantity: d.quantity,
        weight: parseFloat(d.weight),
        price: parseFloat(d.price),
        unitPrice: parseFloat(d.unit_price),
        country: d.country,
        productType: { name: d.product_type_name },
      })),
      totalPrice: p.price,
      totalQuantity: p.total_quantity,
      totalWeight: p.weight,
      createdAt: p.date,
    };
  }
}
